const nestBonus = {
  "Tables": [
    {
      "TableID": "17971087797657243318",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        }
      ]
    },
    {
      "TableID": "17971086698145615107",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        }
      ]
    },
    {
      "TableID": "17971085598633986896",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        }
      ]
    },
    {
      "TableID": "17971093295215384373",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            10,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            5,
            10,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            5,
            10,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        }
      ]
    },
    {
      "TableID": "9420315092197303362",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1588,
          "Values": [
            1,
            1,
            1,
            2,
            2
          ]
        }
      ]
    },
    {
      "TableID": "12771391914844219053",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1588,
          "Values": [
            2,
            2,
            2,
            3,
            3
          ]
        }
      ]
    },
    {
      "TableID": "8987430915849193572",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            3,
            3,
            3,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            3,
            3,
            3
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            3
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1588,
          "Values": [
            2,
            2,
            2,
            3,
            4
          ]
        }
      ]
    },
    {
      "TableID": "15048492610151562099",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            10,
            5,
            5,
            5,
            5
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            5,
            10,
            5,
            5,
            5
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            1,
            5,
            10,
            5,
            5
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            3,
            5,
            5
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            2,
            5
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            3,
            3,
            4,
            4,
            5
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1588,
          "Values": [
            3,
            3,
            3,
            4,
            5
          ]
        }
      ]
    },
    {
      "TableID": "1225377838667257975",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1588,
          "Values": [
            1,
            1,
            1,
            2,
            2
          ]
        }
      ]
    },
    {
      "TableID": "12664219073792399628",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1588,
          "Values": [
            2,
            2,
            2,
            3,
            3
          ]
        }
      ]
    },
    {
      "TableID": "16920638762136026844",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    },
    {
      "TableID": "16920625567996488312",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    },
    {
      "TableID": "15810383647673806751",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            3,
            3,
            3,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            3,
            3,
            3
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            3
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    },
    {
      "TableID": "15810405637906370971",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            10,
            5,
            5,
            5,
            5
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            5,
            10,
            5,
            5,
            5
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            1,
            5,
            10,
            5,
            5
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            3,
            5,
            5
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            2,
            5
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            3,
            3,
            4,
            4,
            5
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            2,
            2,
            2
          ]
        }
      ]
    },
    {
      "TableID": "9994368873407414313",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    },
    {
      "TableID": "9994364475360901469",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    },
    {
      "TableID": "15634642834089547259",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            5,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            1,
            5,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            1,
            5,
            2,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            1,
            3,
            2
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            1
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            1,
            1,
            1,
            1,
            2
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    },
    {
      "TableID": "15634620843856983039",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 1124,
          "Values": [
            7,
            0,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 1125,
          "Values": [
            2,
            7,
            0,
            0,
            0
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1126,
          "Values": [
            0,
            2,
            7,
            3,
            0
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1127,
          "Values": [
            0,
            0,
            2,
            5,
            3
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1128,
          "Values": [
            0,
            0,
            0,
            0,
            3
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1129,
          "Values": [
            2,
            2,
            2,
            2,
            3
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1604,
          "Values": [
            1,
            1,
            1,
            1,
            1
          ]
        }
      ]
    }
  ]
};

  export default nestBonus;